 
import React from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import { IBreadcrumbProps } from "../../../../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import { Mpoi } from "../../../../../csioEdocs/MPOI/Mpoi";
import { useAutomobilePolicyVehcileInfo } from "../hooks/useAutomobileVehicleInfo";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";

export const AutomobileMpoiWrapper: React.FC = () => {
  const { customerId, customerPolicyId, requestUuid } = useParams() as {
    customerId: string;
    customerPolicyId: string;
    requestUuid: string;
  };

  const personalInfo = useSelector((state: IStoreState) => state.customer.personalInformation.data);

  const { vehiclesList , vehcileDropdown,} = useAutomobilePolicyVehcileInfo(Number(customerPolicyId));
  console.log("vehiclesList", vehiclesList);

  const defaultBreadcrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: `/automobile-policy/${customerId}/csio-mpoi/${customerPolicyId}`,
      title: "MPOI LIST",
    },
    {
      title: "Create MPOI",
    },
  ];

  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate(
      `/automobile-policy/${customerId}/csio-mpoi/${customerPolicyId}`
    );
  };
  
  
  return (
    <Mpoi
      onSuccess={handleSuccess}
      breadcrumbItems={defaultBreadcrumb}
      customerId={customerId}
      customerPolicyId={customerPolicyId}
      requestUuid={requestUuid}
      vehicleList={vehiclesList}
      vehcileDropdown={vehcileDropdown}
      policyType="csio:AUTO"
    />
  );
};
